import { connect } from 'react-redux';

import DesktopHeader from './desktop-header.jsx';
import { getRouter } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import {
  getPageTitle,
  getShouldShowTitle,
  getSecondaryLogoData,
  getIsSecondaryLogoEnabled,
  getUseFixedNavLinks
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setIsInPageSearchDisplayed,
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

import {
  getRenderAsMobile,
  getIsInPageSearchEnabled,
  getSocialLinks,
  getShouldShowSocialLinks,
  getHeaderContentPosition,
  getOrderedMainMenuItems,
  getIsFullBleed,
  getTranslationsIsEnabled,
  getTranslationsAppliedLanguages,
  getTranslationsCurrentLanguageIso,
  getTranslationsDefaultLanguageIso
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import { getIsInlineHeaderStyle }
  from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setTranslationsCurrentLanguageIso
} from 'zoomforth_codesbane_editor/action_creators/translations.js';


const mapStateToProps = (state) => {
  const renderAsMobile = getRenderAsMobile(state);
  const socialLinks = getSocialLinks(state);

  const shouldShowSocialLinks = getShouldShowSocialLinks(state);
  const reallyShouldShowSocialLinks =
    shouldShowSocialLinks && !renderAsMobile && socialLinks.length > 0;

  const isInPageSearchEnabled =
    getIsInPageSearchEnabled(state) && !renderAsMobile;
  const displaNavigationLinks = getOrderedMainMenuItems(state).length > 1;

  const isTranslationsEnabled = getTranslationsIsEnabled(state);
  const appliedLanguages = getTranslationsAppliedLanguages(state);
  const currentLanguageIso = getTranslationsCurrentLanguageIso(state);
  const defaultLanguageIso = getTranslationsDefaultLanguageIso(state);

  return {
    pageTitle: getPageTitle(state),
    shouldShowTitle: getShouldShowTitle(state),
    secondaryLogoData: getSecondaryLogoData(state),
    isSecondaryLogoEnabled: getIsSecondaryLogoEnabled(state),
    renderAsMobile,
    headerContentPosition: getHeaderContentPosition(state) || 'Right',
    displaNavigationLinks,
    reallyShouldShowSocialLinks,
    socialLinks,
    includeSearch: isInPageSearchEnabled,
    isInlineHeaderStyle: getIsInlineHeaderStyle(state) || false,
    useFixedNavLinks: getUseFixedNavLinks(state),
    isFullBleed: getIsFullBleed(state),
    isTranslationsEnabled,
    appliedLanguages,
    currentLanguageIso,
    defaultLanguageIso,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onInPageSearchOpenerClick:()=>{
    dispatch(setIsInPageSearchDisplayed(true));
  },
  onHeaderLogoClick: () => {
    getRouter().navigateHome({ trigger: true, replace: false });
  },
  onLanguageChange: (iso)=> {
    dispatch(setTranslationsCurrentLanguageIso(iso));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(DesktopHeader);
